import * as React from 'react'
import { IScrollToTop } from './interface'
import { scrollToTop } from '../../utils/misc'
import { useLocation } from 'react-router-dom'

const ScrollToTop = ({ children }: IScrollToTop) => {
  const LOCATION = useLocation()
  React.useLayoutEffect(() => scrollToTop(true), [LOCATION])
  return children
}

export default ScrollToTop
